






































import Vue from 'vue'
import UiCheckbox from '../../UiCheckbox'
import UiFormField from '../UiFormField'
export default Vue.extend({
  name: 'UiFormCheckbox',
  components: {
    UiCheckbox
  },
  extends: UiFormField,
  methods: {
    input (value: any): void {
      this.$emit('input', value)
    }
  }
})
